<template>
  <v-autocomplete
    v-model="storedUtensils"
    :items="state.items"
    item-text="name"
    item-value="name"
    :search-input.sync="state.search"
    v-on:keyup="debouncedGetData"
    multiple
    clearable
    dense
    hide-details
    outlined
    :menu-props="{ maxHeight: '400', zIndex: 13 }"
    label="Ustensiles"
  />
</template>

<script>
import debounce from "lodash/debounce";
import {
  computed,
  onMounted,
  reactive,
  set,
  watch,
} from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";

const COMPONENT_NAME = "UtensilFilter";

export default {
  name: COMPONENT_NAME,
  props: {
    anchor: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const { store } = useProxy();
    const { axiosGet } = useAxios();
    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const state = reactive({
      search: "",
      items: [],
    });

    const getData = async () => {
      const { data } = await axiosGet("/regie/marmiton/utensils", {
        search_text: state.search,
      });

      set(state, "items", storedUtensils.value.concat(data));
    };

    const debouncedGetData = debounce(getData, 500);

    const storedUtensils = computed({
      get: () => store.getters["marmiton/getMarmitonUtensilsToInclude"],
      set(value) {
        store.dispatch("marmiton/updateMarmitonUtensilsToInclude", value);
      },
    });

    watch(storedUtensils, (newValue) => {
      addQueryStringParam(
        {
          param: URL_PARAM_NAMES[COMPONENT_NAME],
          value: newValue,
          is_multiple: true,
        },
        props.anchor
      );
    });

    onMounted(async () => {
      await getData();
      await synchronizeFilterWithQueryString({
        dispatcher: "marmiton/updateMarmitonUtensilsToInclude",
        param: URL_PARAM_NAMES[COMPONENT_NAME],
        value: storedUtensils.value,
        is_multiple: true,
      });
    });

    return {
      debouncedGetData,
      state,
      storedUtensils,
    };
  },
};
</script>
